import React, { useEffect, useState } from "react";
import axios from "axios";
import { Pencil, Trash2 } from "lucide-react";
import { API_BASE_URL } from "../../utils/adminApi";
import "./AdminServices.css";

const API = API_BASE_URL;

export default function AdminServices() {

const [services,setServices] = useState([]);
const [name,setName] = useState("");
const [subtitle,setSubtitle] = useState("");
const [image,setImage] = useState(null);

/* ================= FETCH SERVICES ================= */

useEffect(()=>{
fetchServices();
},[]);

const fetchServices = async () => {

try{

  const res = await axios.get(`${API}/api/services`);

  setServices(Array.isArray(res.data) ? res.data : []);

}catch(err){

  console.error("Fetch services error",err);

}

};

/* ================= IMAGE UPLOAD ================= */

const handleFile = (e)=>{

const file = e.target.files[0];

if(!file) return;

if(!file.type.startsWith("image/")){
  alert("Please upload image file");
  return;
}

setImage(file);

};

const handleDrop = (e)=>{

e.preventDefault();

const file = e.dataTransfer.files[0];

if(!file) return;

if(!file.type.startsWith("image/")){
  alert("Upload image only");
  return;
}

setImage(file);

};

/* ================= ADD SERVICE ================= */

const handleAddService = async ()=>{

if(!name.trim()){
  alert("Service name required");
  return;
}

const formData = new FormData();

formData.append("name",name);
formData.append("subtitle",subtitle);

if(image){
  formData.append("image",image);
}

try{

  await axios.post(`${API}/api/services`,formData);

  setName("");
  setSubtitle("");
  setImage(null);

  fetchServices();

}catch(err){

  const message = err?.response?.data?.error || "Service add failed";

  alert(message);

  console.error(err);

}

};

/* ================= DELETE SERVICE ================= */

const deleteService = async (id)=>{

if(!window.confirm("Delete service?")) return;

try{

  await axios.delete(`${API}/api/services/${id}`);

  fetchServices();

}catch(err){

  console.error("Delete error",err);

}

};

/* ================= EDIT SERVICE ================= */

const editService = async (service)=>{

const newName = prompt("Edit service name",service.name);

if(!newName) return;

try{

  await axios.put(`${API}/api/services/${service._id}`,{
    name:newName
  });

  fetchServices();

}catch(err){

  console.error("Update error",err);

}

};

return(

<div className="admin-dashboard">

  <h2 className="admin-title">Add Services</h2>

  <div className="admin-card">

    {/* IMAGE DRAG DROP */}

    <div
      className="drag-box"
      onDrop={handleDrop}
      onDragOver={(e)=>e.preventDefault()}
      onClick={()=>document.getElementById("serviceImg").click()}
    >

   {image ? (

  <img
    src={URL.createObjectURL(image)}
    alt="preview"
    className="drag-preview"
  />

) : (

        <div className="drag-content">

          <div className="upload-icon">⬆</div>

          <p>Drag service image here</p>

          <p className="upload-small">or click to upload</p>

        </div>

      )}

      <input
        id="serviceImg"
        type="file"
        accept="image/*"
        style={{display:"none"}}
        onChange={handleFile}
      />

    </div>

    {/* FORM */}

    <div className="admin-form">

      <input
        type="text"
        placeholder="Service name"
        value={name}
        onChange={(e)=>setName(e.target.value)}
      />

      <input
        type="text"
        placeholder="Subtitle"
        value={subtitle}
        onChange={(e)=>setSubtitle(e.target.value)}
      />

      <button
        className="small-btn"
        onClick={handleAddService}
      >
        Add Service
      </button>

    </div>

    {/* SERVICE LIST */}

    <div className="admin-list">

      {services.length === 0 && (
        <div className="admin-empty">
          No services found
        </div>
      )}

      {services.map((service)=>(

        <div
          key={service._id}
          className="admin-list-item"
        >

          {service.image && (
            <img
  src={service.image}
  alt={service.name}
  style={{ width: "60px", height: "60px", objectFit: "cover" }}
/>
    
          )}

          <div className="service-info">

            <strong>{service.name}</strong>

            <p>{service.subtitle}</p>

          </div>

          <div className="admin-actions">

            <button
              className="edit-btn"
              onClick={()=>editService(service)}
            >
              <Pencil size={16}/>
            </button>

            <button
              className="delete-btn"
              onClick={()=>deleteService(service._id)}
            >
              <Trash2 size={16}/>
            </button>

          </div>

        </div>

      ))}

    </div>

  </div>

</div>

);

}
